export default __webpack_public_path__ + "static/media/logo.ea8293a5.png";